// Third party libraries
// Components

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { numberFormatMixins } from "@/app/mixins/modules/number-format-mixins";
// Services
import userService from "@/app/services/main/user/user-service"

// Constants
import { STATUS_CODES } from "@/app/constants/constants"


export default {
	name: 'StoreCreditListContainer',
    components: {},
	mixins: [
		tableMixins,
		toastMessageMixins,
        dateMixins,
        numberFormatMixins
	],
	computed: {
	},
	data() {
		return {
			isAPILoading: false,
			isBreedsLoading: false,
			// table
			theads: [
                {
                    name: "Client ", 
                    searchLabel: "f_clientName", 
                    sortLabel: "clientName",
                    isDesc: false, 
                    hasSearch: true,
                    style: 'null',
                },
                {
                    name: "Shop Balance",
                    searchLabel: "f_amount",
                    sortLabel: "amount",
                    isDesc: false,
                    hasSearch: false,
                    style: "min-width: 150px",
                }
            ],
			// sorting
			desc: true,
			sortBy: '',
			modalContent: {},
            total: 0
		}
	},
	created() {
		this.getTableContent();
	},
    watch: {},
	methods: {
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page
            this.getStoreCreditList({ page, limit, sortBy, desc })
        },
        getStoreCreditList(queryParams) {
            // search filters
            if (this.columnsFilter) {
                const { 
                    f_clientName
                } = this.columnsFilter
                    
                if (f_clientName) {
                    queryParams["f_clientName"] = f_clientName
                }
                
            }

            this.isAPILoading = true

            userService.getStoreCreditList(queryParams).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.tableContent = {
                        tableData: res.data.data,
                        paginationData: res.data.pagination,
                    }
                    this.total = res.data.total
                    this.isAPILoading = false
                } else {
                    this.showAPIErrorToast("Unable to fetch store credit list.", res)
                    this.isAPILoading = false
                }
            })
        },
        goBackToUserList(){
            this.$router.push("/users");
        }
	}
}